import ApiConnector from "../connector";

class NotificationsActions {
  get = async () => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.get("/notifications/");
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.detail;
    }

    return result;
  };
  create = async ({ message, project, time_to_notify }) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.post("/notifications/", { message, project, time_to_notify });
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.detail;
    }

    return result;
  };
  delete = async (id) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.delete(`/notifications/${id}/`);
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.detail;
    }

    return result;
  };
  read = async (id) => {
    const result = {
      value: false,
      error: null,
    };

    try {
      const response = await ApiConnector.connector.post(`/notifications/read/`, {
        notification_ids: [id]
      }
      );
      result.value = response.data;
    } catch (e) {
      result.error = e.response.data.detail;
    }

    return result;
  };
}

export default new NotificationsActions();
